import { render, staticRenderFns } from "./pipedrive-filter-selector.vue?vue&type=template&id=6620b241"
import script from "./pipedrive-filter-selector.vue?vue&type=script&lang=js"
export * from "./pipedrive-filter-selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports